import jQuery from 'jquery'

let G, v, H, S, $target, $window, theta, $self, targetPos, buttonPos

/**
 * 目標に向かって放物線を描くアニメーションの実行
 * @param selfElement 開始位置となる自分自身のelement(jQueryで取得できるもの).
 * @param targetElement 終了位置となる対象のelement(jQueryで取得できるもの).
 */
const start = (selfElement, targetElement) => {
  $target = jQuery(targetElement)
  $window = jQuery(window)
  $self = jQuery(selfElement)
  targetPos = $target.offset()
  buttonPos = $self.offset()
  targetPos.top = targetPos.top - $window.scrollTop()
  buttonPos.top = buttonPos.top - $window.scrollTop()

  targetPos.left = targetPos.left + $target.width() / 2
  buttonPos.left = buttonPos.left + $self.width() / 2

  G = 5 // 重力[px/s^2]
  v = 0 // 初速[px/s]
  H = buttonPos.top - targetPos.top // 高度[px]
  S = targetPos.left - buttonPos.left // 距離[px]
  calcOrbit()
}
const calcOrbit = () => {
  // 解の存在の有無判定に使う値
  const b = -1 * (2 * v * v * S) / (G * S * S)
  const c = 1 + (2 * v * v * H) / (G * S * S)

  const D = b * b - 4 * c // 0以上なら解が存在
  if (D >= 0) {
    // 解が存在する場合はアニメーションを実行

    // 放物線の最初の角度を算出
    const tanTheta0 = Math.atan((-b - Math.sqrt(D)) / 2.5)
    const tanTheta1 = Math.atan((-b + Math.sqrt(D)) / 2.5)
    theta = Math.max(tanTheta0, tanTheta1)

    // アニメーションを実行
    startAnimation()
  } else {
    // 解が存在しない場合は、初速を追加して放物線の軌道を再計算
    v++
    calcOrbit()
  }
}
const startAnimation = () => {
  // アニメーションさせるボールを設置
  jQuery('body').append('<div class="pega-ball"/>')
  const $ball = jQuery('.pega-ball').last()
  $ball.css({
    left: buttonPos.left + 'px',
    top: buttonPos.top + 'px'
  })

  // アニメーション実装
  const startTime = performance.now()
  requestAnimationFrame(loop)
  function loop (nowTime) {
    const t = (nowTime - startTime) / 80 // 時間を取得
    const x = v * Math.cos(theta) * t // 横方向の位置を算出
    const y = Math.tan(theta) * x - (G / (2 * v * v * Math.cos(theta) * Math.cos(theta))) * x * x // 縦方向の位置を算出
    // 算出した値を基にボールの位置を移動
    $ball.css({
      left: Math.round(buttonPos.left + x) + 'px',
      top: Math.round(buttonPos.top - y) + 'px'
    })
    // ボールがカートボタンに到着するまでアニメーションを実行
    if (buttonPos.left + x < targetPos.left) {
      requestAnimationFrame(loop)
    } else {
      // アニメーションの終了処理
      $ball.remove()
    }
  }
}

exports.start = start
